
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import close from '../Asset/close.svg';
import Table from './tables/utilizationTable';
import { Tabs, Tab, Form, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { BarChart, Bar, XAxis, YAxis, PieChart, Cell, CartesianGrid, Tooltip, Pie, Sector, Legend, ResponsiveContainer, Label, LabelList, Line, ComposedChart } from "recharts";
import { getUserInfo, getDashboard } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import moment from 'moment/moment';
import {environment} from './functions/environment';

const COLORS = ['#3368F2', '#FA2C50', '#FF9800', '#795548', '#673AB7', '#8BC34A', '#B7117F', '#55BA9A', '#2C505A', '#C11AC5'];
const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {/* {`${(percent * 100).toFixed(0)}`} */}
            {`${value > 0 ? value : ""}`}
        </text>
    );
};
// for custome tooltip of graph
function CustomTooltip({ payload, label, active }) {
    // console.log("payload:", payload);
    if (active) {
        return (
            <div className="border bg-white p-2">
                <p>{label}</p>
                {
                    payload[0].payload.day == "non-working" ?
                        <>
                            <p>It is non-working day</p>
                            <p style={{ color: "#0077B9" }}>Utilization % : {payload[0].payload.Utilization}</p>
                            <p style={{ color: "#9B034A" }}>Utilization Hrs : {payload[0].payload.Hrs}</p>
                        </>
                        :
                        <>
                            <p>It is working day</p>
                            <p style={{ color: "#0077B9" }}>Utilization % : {payload[0].payload.Utilization}</p>
                            <p style={{ color: "#6FA624" }}>Utilization Hrs : {payload[0].payload.whrs}</p>
                        </>
                }
            </div>
        );
    }

    return null;
}
// for custome tooltip of graph

// const renderCustLabel = (props) => {
//     const { x, y, width, value } = props;
//     const radius = 6;
//     let day = (value.slice(0,1)).toUpperCase();
//     return (
//         <g>
//             {/* <circle cx={x + width / 2} cy={y - radius} r={radius} fill="#0077B9" /> */}
//             <text
//                 x={x + width / 2}
//                 y={y - radius}
//                 fill="#0077B9"
//                 textAnchor="middle"
//                 dominantBaseline="middle"
//             >
//                 {day}
//             </text>
//         </g>
//     );
// };

const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        fill,
        payload,
        percent,
        value
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";

    return (
        <g>
            <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
                {payload.name}
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={fill}
            />
            <path
                d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
                stroke={fill}
                fill="none"
            />
            <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
            <text
                x={ex + (cos >= 0 ? 1 : -1) * 12}
                y={ey}
                textAnchor={textAnchor}
                fill="#333"
            >{` ${value}`}</text>
            <text
                x={ex + (cos >= 0 ? 1 : -1) * 12}
                y={ey}
                dy={18}
                textAnchor={textAnchor}
                fill="#999"
            >
            </text>
        </g>
    );
};



function Utilization() {
    let userObj = getUserInfo();
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    let monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dashboard = sessionStorage.getItem('Dashboards') ? getDashboard() : [];
    let tdate = new Date();
    var dd = String(tdate.getDate()).padStart(2, '0');
    var mm = String(tdate.getMonth() + 1).padStart(2, '0');
    var yyyy = tdate.getFullYear();
    const fillMenu = [101, 102, 104, 109];
    let [sessOut, setSessOut] = useState(false);
    let [filterDash, setFilterDash] = useState(null);
    let [filter, setFilter] = useState({
        equipmentID: "",
        productCategoryID: "",
        productSubCategoryID: "",
        equipmentType: "",
        siteID: "",
        year: "",
        month: "",
        toDate: "",
        fromDate: "",
    });
    let [siteList, setSiteList] = useState([]);
    let [allAseet, setAllAsset] = useState([]);
    let [today, setToday] = useState("");
    let [years, setYears] = useState([]);
    let [eq107, setEq107] = useState(false);
    let [fil103, setFil103] = useState("");
    const [defaultAss, setDefaultAss] = useState("");
    const [defaultTab, setDefaultTab] = useState("first");
    const [error107, setError107] = useState(false);
    let [filterHis, setFilterHis] = useState({
        101: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: ""
        },
        102: {
            productCategoryID: 1,
            productSubCategoryID: "",
            siteID: ""
        },
        103: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            year: "",
            month: yyyy + "-" + mm,
            fromDate: "",
            toDate: "",
        },
        104: {
            productCategoryID: "",
            productSubCategoryID: "",
            siteID: ""
        },
        105: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            year: String(yyyy)
        },
        106: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            month: yyyy + "-" + mm,
            fromDate: "",
            toDate: "",
        },
        107: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            month: yyyy + "-" + mm
        },
        108: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            year: "",
            month: "",
            fromDate: yyyy + "-" + mm + "-" + dd,
            toDate: yyyy + "-" + mm + "-" + dd,
        },
        109: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            //siteID: siteList.length ? siteList[0].siteID : userObj.siteID, // this for by default selected site
            siteID: "",
        },
        110: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: "",
        }
    });
    let [filterDefault, setFilterDefault] = useState({
        101: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: ""
        },
        102: {
            productCategoryID: 1,
            productSubCategoryID: "",
            siteID: ""
        },
        103: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            year: "",
            month: yyyy + "-" + mm,
            fromDate: "",
            toDate: "",
        },
        104: {
            productCategoryID: "",
            productSubCategoryID: "",
            siteID: ""
        },
        105: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            year: String(yyyy)
        },
        106: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            month: yyyy + "-" + mm,
            fromDate: "",
            toDate: "",
        },
        107: {
            equipmentID: allAseet.length ? allAseet[0].assetID : "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            month: yyyy + "-" + mm
        },
        108: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: siteList.length ? siteList[0].siteID : userObj.siteID,
            year: "",
            month: "",
            fromDate: yyyy + "-" + mm + "-" + dd,
            toDate: yyyy + "-" + mm + "-" + dd,
        },
        109: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            //siteID: siteList.length ? siteList[0].siteID : userObj.siteID, // this for by default selected site
            siteID: "",
        },
        110: {
            equipmentID: "",
            productCategoryID: "",
            productSubCategoryID: "",
            equipmentType: "",
            siteID: "",
            // year: "",
            // month: "",
            // fromDate: yyyy + "-" + mm + "-" + dd,
            // toDate: yyyy + "-" + mm + "-" + dd,
        }
    });

    useEffect(() => {
        // let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
        let abortController = new AbortController();
        getSiteList();
        let today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();

        setToday(yyyy + "-" + mm + "-" + dd);
        let tempy = [];
        for (let i = 0; i < 3; i++) {
            tempy.push(yyyy - i);
        }
        setYears(tempy);
        //console.log("testYear",tempy)

        if (globObj && globObj != 'undefined') {
            setEq107(false);
            setFilter(globObj);
            saveGlobelFilter('store', globObj);
        }
        else {
            setFil103(getDurType(filterHis[103]));
            setEq107(true);
            if (dashboard.indexOf(101) >= 0) {
                getOverallUtilization(filterHis[101]);
            }
            if (dashboard.indexOf(102) >= 0) {
                getUtilizationBySubCategory(filterHis[102]);
            }
            if (dashboard.indexOf(103) >= 0) {
                getUtilizationByEquipment(filterHis[103]);
            }
            if (dashboard.indexOf(104) >= 0) {
                getUtilizationByCategory(filterHis[104]);
            }
            if (dashboard.indexOf(105) >= 0) {
                getMonthWise(filterHis[105]);
            }
            if (dashboard.indexOf(106) >= 0) {
                getWeekWise(filterHis[106]);
            }
            if (dashboard.indexOf(107) >= 0) {
                if(filterHis[107].equipmentID == ""){
                    setError107(true);
                }
                else{
                    setError107(false);
                    getDayWise(filterHis[107]);
                }
            }
            if (dashboard.indexOf(108) >= 0) {
                getShiftWise(filterHis[108]);
            }
            if (dashboard.indexOf(109) >= 0) {
                getOperatorWise(filterHis[109]);
            }
            if (dashboard.indexOf(110) >= 0) {
                getEquipmentWise(filterHis[110]);
            }
        }
        // dateFrom: yyyy + "-" + mm + "-" + dd

        getProductCategory();
        getDropDown();

        return () => {
            abortController.abort();
        }

    }, []);

    let [pwidth, setPwidth] = useState(null);
    const parentRef = useRef(null);
    useEffect(() => {
        if (parentRef.current) {
            setPwidth(parentRef.current.offsetWidth)
            //console.log("row-width:",parentRef.current.offsetWidth)
        }
    }, [parentRef]);

    let [overallUtilization, setoverallUtilization] = useState([]);
    let [equipmentData, setequipmentData] = useState([]);
    let [equBySubCat, setEquBySubCat] = useState([]);
    let [equByCat, setEquByCat] = useState([]);
    let [monthWise, setMonthWise] = useState([]);
    let [weekWise, setweekWise] = useState([]);
    let [dayWise, setDayWise] = useState([]);
    let [shiftWise, setShiftWise] = useState([]);
    let [operatorWise, setOperatorWise] = useState([]);
    let [operatorHrs, setOperatorHrs] = useState({
        operatorName: "",
        data: []
    });
    let [equipmentWise, setEquipmentWise] = useState([]);


    let [cate, setCate] = useState([]);
    let [subCate, setSubCate] = useState([]);



    let [dropdownData, setDropDownData] = useState({
        asset_equipmentType: [
            { name: "" },
        ]
    });

    function getProductCategory() {
        fetch(environment.baseUrl + "getProductCategory?", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },

        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                ////console.log("Category:", resp)
                if (resp.code == 200) {
                    setCate(resp.data.result.categories);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setCate([]);
                }
            })
        })
    }
    function getProductSubCategory(pid) {
        fetch(environment.baseUrl + "getProductSubCategory?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    "parentID": pid
                })
        }).then((result) => {
            result.json().then(res => {
                ////console.log("SubCategory:", res.data.result.subCategories);
                if (res.code == 200) {
                    setSubCate(res.data.result.subCategories);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setSubCate([]);
                }
            })
        })
    }

    function getDropDown() {
        fetch(environment.baseUrl + "getDropDown", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "groupName": ["equipmentType"],
                "masterType": ["asset"]
            })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setDropDownData(res.data.result);
                    ////console.log("***** Dropdown Values*******", dropdownData.asset_productCategory);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setDropDownData({
                        asset_equipmentType: [
                            { name: "" },
                        ]
                    })
                }
            })
        })
    }
    function getSiteList() {
        fetch(environment.baseUrl + "getSiteByUserAccount", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                //console.log("getsite:", resp)
                if (resp.code == 200) {
                    setSiteList(resp.data.result.siteList);
                    //console.log("siteList",resp.data.result.siteList)
                    if (eq107) {
                        getEquipmentBySite(filterHis[107].siteID);
                        // getEquipmentBySite(resp.data.result.siteList[0].siteID);
                    }
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setSiteList([]);
                }
            })
        })
    }
    function getAssetList() {
        fetch(environment.baseUrl + "getEquipmentsByUser", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((result) => {
            result.json().then((res) => {
                //console.log(res);
                if (res.code == 200) {
                    setAllAsset(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setAllAsset([]);
                }
            })
        })
    }

    function getEquipmentBySite(sid, type) {
        fetch(environment.baseUrl + "getEquipmentBySite?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    siteID: sid
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    if (type == "default") {
                        // console.log("in default if")
                        (res.data.result).length > 0 ? setDefaultAss(res.data.result[0].assetID) : setDefaultAss("");
                    }
                    else {
                        // console.log("in else paerr")
                        setAllAsset(res.data.result);
                        //code for auto select equipment for daywise
                        // if (eq107) {
                        //     let obj = filterHis[107];
                        //     obj.equipmentID = res.data.result[0].assetID;
                        //     setFilterHis({ ...filterHis, [107]: obj });
                        //     setFilterDefault({ ...filterDefault, [107]: obj })
                        //     setEq107(false);
                        //     getDayWise(filterHis[107]);
                        // }
                        if(eq107 && filterHis[107].equipmentID == ""){
                            setEq107(false);
                            setError107(true);
                        }
                    }
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setAllAsset([]);
                }
            })
        })
    }

    const [show, setShow] = useState(false);
    const [showOpHr, setShowOpHr] = useState(false);
    const handleClose = () => {
        setShow(false);
        setSubCate([]);
        setFilter({
            equipmentID: "",
            equipmentType: "",
            siteID: "",
            fromDate: "",
            toDate: "",
            month: "",
            year: "",
            productCategoryID: "",
            productSubCategoryID: "",
        });
    };
    const handleShow = (dashID) => {
        setFilterDash(dashID);
        setFilter(filterHis[dashID]);
        if (filterHis[dashID].siteID == "" || filterHis[dashID].siteID == undefined) {
            getAssetList();
        }
        else {
            getEquipmentBySite(filterHis[dashID].siteID);
        }
        if (filterHis[dashID].productCategoryID != "") {
            getProductSubCategory(filterHis[dashID].productCategoryID)
        }
        setShow(true);
        //console.log("dashID:", dashID);
    }
    function opHrClose() {
        setShowOpHr(false);
        setOperatorHrs({
            operatorName: "",
            data: []
        })
    }
    function clearFilter(dashID) {
        let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
        setAllAsset([]);

        if (globObj && globObj != 'undefined') {
            setEq107(true);
            sessionStorage.removeItem('GloberFilter');
            getOverallUtilization(filterDefault[101]);
            getUtilizationBySubCategory(filterDefault[102]);
            getUtilizationByEquipment(filterDefault[103]);
            getUtilizationByCategory(filterDefault[104]);
            getMonthWise(filterDefault[105]);
            getWeekWise(filterDefault[106]);
            setError107(true);setDayWise([]);//getDayWise(filterDefault[107]); 
            getShiftWise(filterDefault[108]);
            getOperatorWise(filterDefault[109]);
            getEquipmentWise(filterDefault[110]);
            setFilterHis(filterDefault);
        }
        else {
            setFilterHis({ ...filterHis, [dashID]: filterDefault[dashID] });
            if (dashID == 101) {
                getOverallUtilization(filterDefault[101]);
            }
            if (dashID == 102) {
                getUtilizationBySubCategory(filterDefault[102]);
            }
            if (dashID == 103) {
                getUtilizationByEquipment(filterDefault[103]);
            }
            if (dashID == 104) {
                getUtilizationByCategory(filterDefault[104]);
            }
            if (dashID == 105) {
                getMonthWise(filterDefault[105]);
            }
            if (dashID == 106) {
                getWeekWise(filterDefault[106]);
            }
            if (dashID == 107) {
                getDayWise(filterDefault[107]);
            }
            if (dashID == 108) {
                getShiftWise(filterDefault[108]);
            }
            if (dashID == 109) {
                getOperatorWise(filterDefault[109]);
            }
            if (dashID == 110) {
                getEquipmentWise(filterDefault[110]);
            }
        }
        setError(false);
        handleClose();
    }

    function getFilterData(e) {
        // console.log("dash-----:",filterDash);
        if (e.target.name === "productCategoryID") {
            setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
            getProductSubCategory(parseInt(e.target.value));
        }
        else if (e.target.name === "productSubCategoryID" || e.target.name === "siteID") {
            setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
            if (e.target.name === "siteID") {
                getEquipmentBySite(e.target.value);
            }
        }
        else if (e.target.name == "fromDate") {
            setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "", toDate: "" });
            if (filterDash == 106) {
                getWeekLastDay(e.target.value);
            }
        }
        else if (e.target.name == "toDate") {
            setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "" });
        }
        else if (e.target.name == "month") {
            setFilter({ ...filter, [e.target.name]: e.target.value, year: "", fromDate: "", toDate: "" });
        }
        else if (e.target.name == "year") {
            setFilter({ ...filter, [e.target.name]: e.target.value, month: "", fromDate: "", toDate: "" });
        }
        else {
            setFilter({ ...filter, [e.target.name]: e.target.value });
        }
    }

    let [error, setError] = useState("");
    function getFilterFields() {
        setFilterHis({ ...filterHis, [filterDash]: filter })
        ////console.log("FILTERDATA", filter);
        if (filterDash == 101) {
            getOverallUtilization(filter);
        }
        else if (filterDash == 102) {
            getUtilizationBySubCategory(filter);
        }
        else if (filterDash == 103) {
            setFil103(getDurType(filter));
            getUtilizationByEquipment(filter);
        }
        else if (filterDash == 104) {
            getUtilizationByCategory(filter);
        }
        else if (filterDash == 105) {
            getMonthWise(filter);
        }
        else if (filterDash == 106) {
            getWeekWise(filter);
        }
        else if (filterDash == 107) {
            if (filter.equipmentID == "") {
                setDayWise([]);
                setError107(true);
                handleClose();
            }
            else {
                getDayWise(filter);
            }
        }
        else if (filterDash == 108) {
            getShiftWise(filter);
        }
        else if (filterDash == 109) {
            getOperatorWise(filter);
        }
        else {
            getEquipmentWise(filter);
        }
    }



    // PIE CHART DATA
    const [activeIndex, setActiveIndex] = useState(0);
    const onPieEnter = useCallback(
        (_, index) => {
            setActiveIndex(index);
        },
        [setActiveIndex]
    );
    //1
    function getOverallUtilization(obj) {
        fetch(environment.baseUrl + "overallUtilization?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    equipmentID: obj.equipmentID,
                    productCategoryID: obj.productCategoryID,
                    productSubCategoryID: obj.productSubCategoryID,
                    equipmentType: obj.equipmentType,
                    siteID: obj.siteID
                }
            )
        }).then((result) => {
            result.json().then((res) => {
                let color = ["#0077B9", "#6FA624", "#aa336a"];
                let temp = [];
                if (res.code == 200) {
                    res.data.chartData.map((item, index) =>
                        temp.push({ name: item[0], value: item[1], fill: color[index] })
                    )
                    setoverallUtilization(temp);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setoverallUtilization([]);
                }
                handleClose();
                //console.log("OverAllUtilizationData:", res);
            })
        })
    }
    //2
    function getUtilizationByEquipment(obj) {
        fetch(environment.baseUrl + "utilizationByEquipment?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                equipmentID: obj.equipmentID,
                productCategoryID: obj.productCategoryID,
                productSubCategoryID: obj.productSubCategoryID,
                equipmentType: obj.equipmentType,
                siteID: obj.siteID,
                year: obj.year,
                month: obj.month,
                dateFrom: obj.fromDate != "" ? obj.fromDate + " 00:00:00" : "",
                dateTo: obj.toDate != "" ? obj.toDate + " 23:59:59" : "",
            })

        }).then((result) => {
            result.json().then((res) => {
                let newTemp = [];
                if (res.code == 200) {
                    res.data.chartData.forEach((element, index) => {
                        if (res.data.thresholdArray[index][1] > element[1]) {
                            newTemp.push({ 'name': element[0], 'Utilization': element[1], fill: "#8B0000" });//red
                        }
                        else {
                            newTemp.push({ 'name': element[0], 'Utilization': element[1], fill: "#477508" });//green

                        }
                    });
                    setequipmentData(newTemp);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setequipmentData([])
                }
                handleClose();
                //console.log("setequipmentData", res);
            })
        })
    }
    //3
    function getUtilizationBySubCategory(obj) {
        fetch(environment.baseUrl + "equipmentCountBySubCategoryReport? ", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                productCategoryID: obj.productCategoryID,
                productSubCategoryID: obj.productSubCategoryID,
                siteID: obj.siteID
            })
        }).then((result) => {
            result.json().then((res) => {
                let temp = [];
                if (res.code == 200) {
                    res.data.equipmentBySubCategory.map((item) =>
                        temp.push({ name: item[0], value: item[1] })
                    )
                    setEquBySubCat(temp);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setEquBySubCat([]);
                }
                handleClose();
                //console.log("OverAllUtilizationDataPiChart?:", res);
            })
        })
    }
    //4
    function getUtilizationByCategory(obj) {
        fetch(environment.baseUrl + "utilizationCategoryReport?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                productCategoryID: obj.productCategoryID,
                productSubCategoryID: obj.productSubCategoryID,
                siteID: obj.siteID
            })
        }).then((result) => {
            result.json().then((res) => {
                let newTemp = [];
                if (res.code == 200) {
                    res.data.equipmentByCategory.forEach(element => {
                        newTemp.push({ name: element[0], Diesel: element[1], Electric: element[2], Other: element[3] })
                    });
                    setEquByCat(newTemp);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setEquByCat([]);
                }
                handleClose();
                //console.log("utilizationCategoryReport?:", res);
            })
        })
    }
    //5
    function getMonthWise(obj) {
        fetch(environment.baseUrl + "monthWiseUtilization", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    equipmentID: obj.equipmentID,
                    productCategoryID: obj.productCategoryID,
                    productSubCategoryID: obj.productSubCategoryID,
                    equipmentType: obj.equipmentType,
                    siteID: obj.siteID,
                    year: obj.year
                }
            )
        }).then((result) => {
            result.json().then((res) => {
                let newTemp = [];
                if (res.code == 200) {
                    if (res.data.chartData.length) {
                        res.data.chartData.forEach(element => {
                            newTemp.push({ 'name': element[0], 'Months': element[0], 'Utilization': element[1] })
                        });
                        setMonthWise(newTemp);
                    }
                    else {
                        setMonthWise([]);
                    }
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setMonthWise([]);
                }
                handleClose();
                //console.log("monthWiseUtilization:", res);
            })
        })
    }
    //6
    function getWeekWise(obj) {
        fetch(environment.baseUrl + "weekWiseUtilization", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    equipmentID: obj.equipmentID,
                    productCategoryID: obj.productCategoryID,
                    productSubCategoryID: obj.productSubCategoryID,
                    equipmentType: obj.equipmentType,
                    siteID: obj.siteID,
                    month: obj.month,
                    dateFrom: obj.fromDate,
                    dateTo: obj.toDate
                }
            )
        }).then((result) => {
            result.json().then((res) => {
                let newTemp = [];
                if (res.code == 200) {
                    res.data.chartData.forEach(element => {
                        newTemp.push({ 'name': element[0], 'Week': element[0], 'Utilization': element[1] })
                    });
                    setweekWise(newTemp);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setweekWise([]);
                }
                handleClose();
                //console.log("WeekWiseUtilization:", res);
            })
        })
    }
    //7
    function getDayWise(obj) {
        // console.log("dayobject:",obj);
        // if (obj.equipmentID != "") {
        setError107(false);
        fetch(environment.baseUrl + "dayWiseUtilization?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                equipmentID: obj.equipmentID,
                productCategoryID: obj.productCategoryID,
                productSubCategoryID: obj.productSubCategoryID,
                equipmentType: obj.equipmentType,
                siteID: obj.siteID,
                month: obj.month
            })
        }).then((result) => {
            result.json().then((res) => {
                let newTemp = [];
                if (res.code == 200) {
                    res.data.chartData.forEach(element => {
                        newTemp.push({ 'name': element[0], 'Utilization': element[1], 'Hrs': element[3] == "non-working" ? element[2] : 0, whrs: element[3] == "working" ? element[2] : 0, day: element[3] })
                    });
                    setDayWise(newTemp);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setDayWise([]);
                }
                handleClose();
                //console.log("DayWiseData", res);
            })
        })
    }
    //8
    let [shiftCol, setShiftCol] = useState([]);
    function getShiftWise(obj) {
        fetch(environment.baseUrl + "equipmentWiseShiftData", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                equipmentID: obj.equipmentID,
                productCategoryID: obj.productCategoryID,
                productSubCategoryID: obj.productSubCategoryID,
                equipmentType: obj.equipmentType,
                siteID: obj.siteID,
                year: obj.year,
                month: obj.month,
                dateFrom: obj.fromDate != "" ? obj.fromDate + " 00:00:00" : "",
                dateTo: obj.toDate != "" ? obj.toDate + " 23:59:59" : "",
            })
        }).then((result) => {
            result.json().then(res => {
                handleClose();
                if (res.code == 200) {
                    let tempCol = [{
                        Header: 'Equipment ID ',
                        accessor: 'equipmentID'
                    }];
                    let tempData = [];

                    res.data.shiftNames.map((item, index) =>
                        tempCol.push({
                            Header: item,
                            accessor: item + index
                        })
                    )
                    setShiftCol(tempCol);

                    res.data.list.forEach(element => {
                        let temp = {};
                        element.map((item, index) =>
                            temp[tempCol[index].accessor] = item
                        )
                        tempData.push(temp);
                    });
                    setShiftWise(tempData);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setShiftWise([]);
                }
            })
        })
    }
    //9
    function getOperatorWise(obj) {
        fetch(environment.baseUrl + "operatorVsEquipment", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                equipmentID: obj.equipmentID,
                productCategoryID: obj.productCategoryID,
                productSubCategoryID: obj.productSubCategoryID,
                equipmentType: obj.equipmentType,
                siteID: obj.siteID
            })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    let temp = []
                    res.data.operatorList.map((item) =>
                        temp.push({ operatorID: item.operatorID, operatorName: item.operatorName, hrsOperated: item.hoursOperated })
                    )
                    setOperatorWise(temp);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setOperatorWise([]);
                }
                handleClose();
            })

        })
    }
    //10
    function getEquipmentWise(obj) {
        fetch(environment.baseUrl + "equipmentWiseInstallationAndOperatedData", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                equipmentID: obj.equipmentID,
                productCategoryID: obj.productCategoryID,
                productSubCategoryID: obj.productSubCategoryID,
                equipmentType: obj.equipmentType,
                siteID: obj.siteID,
            })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setEquipmentWise(res.data.list);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setEquipmentWise([]);
                }
                handleClose();
            })
        })

    }
    function getOperatorEquipmentUtilization(oid, oname) {
        fetch(environment.baseUrl + "operatorEquipmentUtilization", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                operatorID: oid,
                siteID: filterHis[109].siteID
            })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setOperatorHrs({
                        operatorName: oname,
                        data: res.data.assetListbyOperator
                    });
                    setShowOpHr(true);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setOperatorHrs({
                        operatorName: "",
                        data: []
                    });
                }
            })
        })
    }
    //////////////////////Shift Wise DataTAble////////////////////

    const columns = useMemo(
        () => [
            {
                Header: 'EquipementId ',
                accessor: 'equipmentID', // accessor is the "key" in the data
            },
            {
                Header: 'Shift1 ',
                accessor: 'data[0]',
            },
            {
                Header: 'Shift2 ',
            },
            {
                Header: 'Shift3 '
            },

        ],
        []
    );
    const columns_equipment = useMemo(
        () => [
            {
                Header: 'Equipment ID ',
                accessor: 'equipmentID', // accessor is the "key" in the data
            },
            {
                Header: 'Hrs. at Installation ',
                accessor: 'installationReading',
            },
            {
                Header: 'Present Hour Meter Reading ',
                //Header: 'Hrs. Operated ',
                accessor: 'currentReading',
            },
        ],
        []
    );

    const columns_operator = useMemo(
        () => [

            {
                Header: 'Operator Name',
                accessor: 'operatorName',
            },
            {
                Header: 'Total Hrs. Operated',
                accessor: 'hrsOperated',
            },
        ],
        []
    );
    const columns_opHr = useMemo(
        () => [
            {
                Header: 'Equipment ',
                accessor: 'assetID',
            },
            {
                Header: 'Total Hours Operated',
                accessor: 'hoursOperated',
            }
        ],
        []
    );

    let [lastDate, setLastDate] = useState("");
    function getWeekLastDay(std) {
        //logic as per ISO week
        // let startDay = moment(std);
        // let curWeek = moment(startDay).isoWeek();
        // let newWeek = moment().isoWeek(curWeek+7);
        // let lastDay = newWeek.endOf('isoWeek');

        // let date = moment(lastDay).format('YYYY-MM-DD');
        // console.log("Last Date:"+date+"Week:"+curWeek);
        // setLastDate(date);
        //logic as per ISO week

        var new_date = moment(std).add(49, 'days');
        var date8w = moment(new_date).format('YYYY-MM-DD');
        let calDate = new Date(date8w);
        let todate = new Date(today);
        if(calDate < todate)
        {
            setLastDate(date8w);
        }
        else{
            setLastDate(today);
        }

    }
    function dateConvert(dt) {
        let yy = dt.slice(0, 4);
        let mm = parseInt(dt.slice(-2));
        return yy + " " + monthName[mm - 1];
    }
    function checkDurFilter(filObj) {
        if (filObj.fromDate != "" || filObj.toDate != "" || filObj.year != "" || filObj.month != "") {
            return true;
        }
        else {
            return false
        }
    }
    function saveGlobelFilter(type, obj) {
        getEquipmentBySite(userObj.siteID, "default");
        // console.log("saveglob fun")
        let val = {}, flag = false;
        var hisObj;
        if (type == "store") {
            val = obj;
        }
        else {
            sessionStorage.setItem("GloberFilter", JSON.stringify({
                equipmentID: filter.equipmentID ? filter.equipmentID : "",
                equipmentType: filter.equipmentType ? filter.equipmentType : "",
                siteID: filter.siteID ? filter.siteID : "",
                fromDate: filter.fromDate ? filter.fromDate : "",
                toDate: filter.toDate ? filter.toDate : "",
                month: filter.month ? filter.month : "",
                year: filter.year ? filter.year : "",
                productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
                productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
            }));
            val = {
                equipmentID: filter.equipmentID ? filter.equipmentID : "",
                equipmentType: filter.equipmentType ? filter.equipmentType : "",
                siteID: filter.siteID ? filter.siteID : "",
                fromDate: filter.fromDate ? filter.fromDate : "",
                toDate: filter.toDate ? filter.toDate : "",
                month: filter.month ? filter.month : "",
                year: filter.year ? filter.year : "",
                productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
                productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
            };
        }
        // console.log("vall:",val);
        flag = checkDurFilter(val);
        hisObj = {
            "101": val,
            "102": {
                siteID: val.siteID,
                productCategoryID: val.productCategoryID != "" ? val.productCategoryID : 1,
                productSubCategoryID: val.productSubCategoryID,
                // by:"global"
            },
            "103": flag ? {
                equipmentID: val.equipmentID,
                equipmentType: val.equipmentType,
                siteID: val.siteID != "" ? val.siteID : userObj.siteID,
                fromDate: val.fromDate,
                toDate: val.toDate,
                month: val.month,
                year: val.year,
                productCategoryID: val.productCategoryID,
                productSubCategoryID: val.productSubCategoryID
            } : {
                equipmentID: val.equipmentID,
                equipmentType: val.equipmentType,
                siteID: val.siteID != "" ? val.siteID : userObj.siteID,
                fromDate: yyyy + "-" + mm + "-" + dd,
                toDate: yyyy + "-" + mm + "-" + dd,
                month: val.month,
                year: val.year,
                productCategoryID: val.productCategoryID,
                productSubCategoryID: val.productSubCategoryID
            },
            "104": val,
            "105": {
                equipmentID: val.equipmentID,
                equipmentType: val.equipmentType,
                siteID: val.siteID != "" ? val.siteID : userObj.siteID,
                year: val.year != "" ? val.year : String(yyyy),
                productCategoryID: val.productCategoryID,
                productSubCategoryID: val.productSubCategoryID
            },
            "106": generate106Obj(val),
            "107": {
                equipmentID: val.equipmentID,
                equipmentType: val.equipmentType,
                siteID: val.siteID != "" ? val.siteID : userObj.siteID,
                month: val.month != "" ? val.month : yyyy + "-" + mm,
                productCategoryID: val.productCategoryID,
                productSubCategoryID: val.productSubCategoryID
            },
            "108": flag ? {
                equipmentID: val.equipmentID,
                equipmentType: val.equipmentType,
                siteID: val.siteID != "" ? val.siteID : userObj.siteID,
                fromDate: val.fromDate,
                toDate: val.toDate,
                month: val.month,
                year: val.year,
                productCategoryID: val.productCategoryID,
                productSubCategoryID: val.productSubCategoryID
            } : {
                equipmentID: val.equipmentID,
                equipmentType: val.equipmentType,
                siteID: val.siteID != "" ? val.siteID : userObj.siteID,
                fromDate: yyyy + "-" + mm + "-" + dd,
                toDate: yyyy + "-" + mm + "-" + dd,
                month: val.month,
                year: val.year,
                productCategoryID: val.productCategoryID,
                productSubCategoryID: val.productSubCategoryID
            },
            "109": val,
            "110": val,
        }
        setFilterHis(hisObj);
        setFil103(getDurType(hisObj[103]));
        // dashList.forEach(element => {
        // });
        allApiCall(hisObj);
        // console.log(hisObj);
    }
    function allApiCall(req) {
        if (dashboard.indexOf(101) >= 0) {
            getOverallUtilization(req[101]);
        }
        if (dashboard.indexOf(102) >= 0) {
            getUtilizationBySubCategory(req[102]);
        }
        if (dashboard.indexOf(103) >= 0) {
            getUtilizationByEquipment(req[103]);
        }
        if (dashboard.indexOf(104) >= 0) {
            getUtilizationByCategory(req[104]);
        }
        if (dashboard.indexOf(105) >= 0) {
            getMonthWise(req[105]);
        }
        if (dashboard.indexOf(106) >= 0) {
            getWeekWise(req[106]);
        }
        if (dashboard.indexOf(107) >= 0) {
            if (req[107].equipmentID == "") {
                setDayWise([]);
                setError107(true);
            }
            else {
                // console.log("call forn api call fun");
                getDayWise(req[107]);
            }
        }
        if (dashboard.indexOf(108) >= 0) {
            getShiftWise(req[108]);
        }
        if (dashboard.indexOf(109) >= 0) {
            getOperatorWise(req[109]);
        }
        if (dashboard.indexOf(110) >= 0) {
            getEquipmentWise(req[110]);
        }
    }

    function loadTabApi(e) {
        // let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
        setDefaultTab(e);
        // console.log("in new fun:", e,globObj);
    }
    function getDurType(obj) {
        if (obj.year != "") {
            return ": " + obj.year
        }
        else if (obj.month != "") {
            let yy = obj.month.slice(0, 4);
            let mm = parseInt(obj.month.slice(-2));
            return ": " + yy + " " + monthName[mm - 1]
        }
        else if (obj.fromDate != "" && obj.toDate) {
            return ": " + obj.fromDate + " to " + obj.toDate
        }
        else {
            return ""
        }
    }
    function cal8week(sd, ed) {
        let start = new Date(sd);
        let end = new Date(ed);
        let timeDiff = end.getTime() - start.getTime();
        let dayDiff = timeDiff / (1000 * 3600 * 24);
        if (dayDiff <= 49) {
            return true;
        }
        else {
            return false;
        }
    }
    function generate106Obj(obj) {
        if ((obj.fromDate != "" && obj.toDate != "") && cal8week(obj.fromDate, obj.toDate)) {
            getWeekLastDay(obj.fromDate);
            return {
                equipmentID: obj.equipmentID,
                equipmentType: obj.equipmentType,
                siteID: obj.siteID != "" ? obj.siteID : userObj.siteID,
                month: obj.month,
                productCategoryID: obj.productCategoryID,
                productSubCategoryID: obj.productSubCategoryID,
                fromDate: obj.fromDate,
                toDate: obj.toDate,
            }
        }
        else {
            return {
                equipmentID: obj.equipmentID,
                equipmentType: obj.equipmentType,
                siteID: obj.siteID != "" ? obj.siteID : userObj.siteID,
                month: obj.month != "" ? obj.month : yyyy + "-" + mm,
                productCategoryID: obj.productCategoryID,
                productSubCategoryID: obj.productSubCategoryID,
                fromDate: "",
                toDate: "",
            }
        }
    }
    return (
        <div className='main-container'>
            <SessionFun show={sessOut}></SessionFun>
            <h4 className='main-heading'>Utilization Dashboard</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Utilization Dashboard</p>
            <div className="row">
                <Tabs className='tab-menu' defaultActiveKey="first" id="uncontrolled-tab-example" onSelect={loadTabApi}>
                    <Tab eventKey="first" title="Equipment on IOT">
                        <div className="row mt-3">
                            {
                                dashboard.indexOf(101) == -1 ? "" :
                                    <div className="col-sm-6 left-col">
                                        <div className="card-box-block">
                                            <div className="row">
                                                <div className="col-sm-10">
                                                    <h6 className='cardtitle'>Machine Engine Type Wise</h6>
                                                </div>
                                                <div className="col-sm-2  text-end">
                                                    <FontAwesomeIcon icon={faBars} onClick={() => handleShow(101)} />
                                                </div>
                                            </div>
                                            <hr />
                                            {
                                                overallUtilization.length ?
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <PieChart>
                                                            <Legend />
                                                            <Pie
                                                                activeIndex={activeIndex}
                                                                activeShape={renderActiveShape}
                                                                data={overallUtilization}
                                                                margin={{
                                                                    top: 5,
                                                                    right: 30,
                                                                    left: 10,
                                                                    bottom: 20,
                                                                }}
                                                                cx="50%"
                                                                cy="50%"
                                                                innerRadius={60}
                                                                outerRadius={80}
                                                                fill="#8884d8"
                                                                dataKey="value"
                                                                onMouseEnter={onPieEnter}
                                                            />
                                                        </PieChart>
                                                    </ResponsiveContainer>
                                                    :
                                                    <p className='text-center'><b>No Data Available</b></p>
                                            }
                                        </div>
                                    </div>
                            }
                            {
                                dashboard.indexOf(102) == -1 ? "" :
                                    <div className="col-sm-6 card-box-block">
                                        <div className="row">
                                            <div className="col-sm-10">
                                                <h6 className='cardtitle'>Product Sub-Category Wise</h6>
                                            </div>
                                            <div className="col-sm-2  text-end">
                                                <FontAwesomeIcon icon={faBars} onClick={() => handleShow(102)} />
                                            </div>
                                        </div>
                                        <hr />
                                        {
                                            equBySubCat.length ?
                                                <>
                                                    <ResponsiveContainer width="100%" height={250}>
                                                        <PieChart>
                                                            <Legend layout="vertical" verticalAlign="middle" align="right" />
                                                            <Pie
                                                                data={equBySubCat}
                                                                cx="50%"
                                                                cy="50%"
                                                                labelLine={false}
                                                                label={renderCustomizedLabel}
                                                                outerRadius={80}
                                                                fill="#8884d8"
                                                                dataKey="value"
                                                            >
                                                                {equBySubCat.map((entry, index) => (
                                                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                                ))}
                                                            </Pie>
                                                            <Tooltip />
                                                        </PieChart>
                                                    </ResponsiveContainer>
                                                    <div className="row justify-content-center mt-0">
                                                        <Form.Group>
                                                            <Form.Control type='text' className="textbox-back text-center" value={cate.length > 0 ? cate[(filterHis[102].productCategoryID) - 1].categoryName : ""} readOnly>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>
                                                </>
                                                :
                                                <p className='text-center'><b>No Data Available</b></p>
                                        }
                                    </div>

                            }
                        </div>
                        <div className="row mt-3">
                            {
                                dashboard.indexOf(104) == -1 ? "" :
                                    <div className="col-sm-12 full-col">
                                        <div className="card-box-block">
                                            <div className="row">
                                                <div className="col-sm-10">
                                                    <h6 className='cardtitle'>Category Wise Diesel/Electrical</h6>
                                                </div>
                                                <div className="col-sm-2  text-end">
                                                    <FontAwesomeIcon icon={faBars} onClick={() => handleShow(104)} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='row text-center'>
                                                {
                                                    equByCat.length ?
                                                        <ResponsiveContainer width="100%" height={300}>
                                                            <BarChart
                                                                data={equByCat} //// use only when you use second methode
                                                                margin={{
                                                                    top: 5,
                                                                    right: 30,
                                                                    left: 20,
                                                                    bottom: 3
                                                                }}
                                                                barSize={20}
                                                            >
                                                                <CartesianGrid vertical={false} strokeDasharray="3 3" />
                                                                <XAxis dataKey="name" />
                                                                <YAxis />
                                                                <Tooltip />
                                                                <Legend />
                                                                <Bar dataKey="Diesel" stackId="a" fill="#0077B9" />
                                                                <Bar dataKey="Electric" stackId="a" fill="#6FA624" />
                                                                <Bar dataKey="Other" stackId="a" fill="#c12065" />
                                                            </BarChart>
                                                        </ResponsiveContainer>
                                                        :
                                                        <p className='text-center'><b>No Data Available</b></p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                            }

                        </div>
                        <div className="row mt-3">

                            {
                                dashboard.indexOf(103) == -1 ? "" :
                                    <div className="col-sm-12 card-box-block">
                                        <div className="row">
                                            <div className="col-sm-10">
                                                <h6 className='cardtitle'>Equipment Wise Utilization (%) {fil103}</h6>
                                            </div>
                                            <div className="col-sm-2  text-end">
                                                <FontAwesomeIcon icon={faBars} onClick={() => handleShow(103)} />
                                            </div>
                                        </div>
                                        <hr />
                                        <div className='row horizontal-scroll' ref={parentRef}>
                                            {
                                                equipmentData.length ?
                                                    <BarChart
                                                        width={pwidth - 30 > equipmentData.length * 100 ? pwidth - 30 : equipmentData.length * 130}
                                                        height={300}
                                                        data={equipmentData}
                                                        margin={{
                                                            top: 5,
                                                            right: 30,
                                                            left: 10,
                                                            bottom: 5,
                                                        }}
                                                        barSize={20}
                                                    >
                                                        <CartesianGrid vertical={false} strokeDasharray="3 3" />
                                                        <XAxis dataKey="name" />
                                                        <YAxis />
                                                        <Tooltip />

                                                        {/* <Bar dataKey="pv" fill="#8884d8" /> */}
                                                        <Bar dataKey="Utilization" fill="#0077B9" />
                                                    </BarChart>
                                                    :
                                                    <p className='text-center'><b>No Data Available</b></p>
                                            }
                                        </div>
                                    </div>
                            }
                        </div>
                    </Tab>
                    <Tab eventKey="second" title="Duration Wise Utilization">
                        {
                            dashboard.indexOf(105) == -1 ? "" :
                                <div className="row mt-3">
                                    <div className="col-sm-12 full-col">
                                        <div className="card-box-block">
                                            <div className="row">
                                                <div className="col-sm-10">
                                                    <h6 className='cardtitle'>Month Wise Utilization (%) : {filterHis['105'].year}</h6>
                                                </div>
                                                <div className="col-sm-2  text-end">
                                                    <FontAwesomeIcon icon={faBars} onClick={() => handleShow(105)} />
                                                </div>
                                            </div>
                                            <hr />
                                            {
                                                monthWise.length ?
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <BarChart
                                                            data={monthWise}
                                                            margin={{
                                                                top: 5,
                                                                right: 30,
                                                                left: 10,
                                                                bottom: 5,
                                                            }}
                                                            barSize={20}
                                                        >
                                                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            {/* <Bar dataKey="pv" fill="#8884d8" /> */}
                                                            <Bar dataKey="Utilization" fill="#0077B9" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                    :
                                                    <p className='text-center'><b>No Data Available</b></p>
                                            }
                                        </div>
                                    </div>
                                </div>
                        }
                        {
                            dashboard.indexOf(106) == -1 ? "" :
                                <div className="row mt-3">
                                    <div className="col-sm-12 full-col">
                                        <div className="card-box-block">
                                            <div className="row">
                                                <div className="col-sm-10">
                                                    <h6 className='cardtitle'>Week Wise Utilization (%) :  {filterHis['106'].month != "" ? dateConvert(filterHis['106'].month) : filterHis['106'].fromDate + " To " + filterHis['106'].toDate}</h6>
                                                </div>
                                                <div className="col-sm-2  text-end">
                                                    <FontAwesomeIcon icon={faBars} onClick={() => handleShow(106)} />
                                                </div>
                                            </div>
                                            <hr />
                                            {
                                                weekWise.length ?
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <BarChart
                                                            data={weekWise}
                                                            margin={{
                                                                top: 5,
                                                                right: 30,
                                                                left: 10,
                                                                bottom: 5,
                                                            }}
                                                            barSize={20}
                                                        >
                                                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            {/* <Bar dataKey="pv" fill="#8884d8" /> */}
                                                            <Bar dataKey="Utilization" fill="#0077B9" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                    :
                                                    <p className='text-center'><b>No Data Available</b></p>
                                            }
                                        </div>
                                    </div>
                                </div>
                        }

                        {
                            dashboard.indexOf(107) == -1 ? "" :
                                <div className="row mt-3">
                                    <div className="col-sm-12 full-col">
                                        <div className="card-box-block">
                                            <div className="row">
                                                <div className="col-sm-10">
                                                    <h6 className='cardtitle'>Day Wise Utilization (%) : {dateConvert(filterHis['107'].month)} {filterHis['107'].equipmentID ? "-" + filterHis['107'].equipmentID : ""}</h6>
                                                </div>
                                                <div className="col-sm-2  text-end">
                                                    <FontAwesomeIcon icon={faBars} onClick={() => handleShow(107)} />
                                                </div>
                                            </div>
                                            <hr />
                                            {
                                                dayWise.length ?
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <ComposedChart
                                                            data={dayWise}
                                                            margin={{
                                                                top: 5,
                                                                right: 30,
                                                                left: 10,
                                                                bottom: 5,
                                                            }}
                                                            barSize={20}
                                                        >
                                                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            {/* <YAxis /> */}
                                                            <YAxis yAxisId="left" orientation="left" stroke="#0077B9" label={{ value: 'Utilization %', angle: -90, position: 'insideLeft', offset: 3 }}>
                                                                {/* <Label value="Utilization %" offset={2} position="insideLeft" /> */}
                                                            </YAxis>
                                                            <YAxis yAxisId="right" orientation="right" stroke="#9B034A" label={{ value: 'Utilization Hrs', angle: 90, position: 'insideRight' }} />
                                                            {/* <Tooltip /> */}
                                                            <Tooltip content={<CustomTooltip />} />
                                                            <Legend />
                                                            {/* <Bar dataKey="Utilization" fill="#0077B9" /> */}
                                                            {/* <Bar yAxisId="left" dataKey="Utilization" name='Utilization %' fill="#0077B9" /> */}
                                                            <Bar yAxisId="right" dataKey="whrs" name='Utilization Hrs on Working Day' stackId="a" fill="#6FA624"></Bar>
                                                            <Bar yAxisId="right" dataKey="Hrs" name='Utilization Hrs on Non Working Day' stackId="a" fill="#9B034A"></Bar>
                                                            <Line yAxisId="left" type="monotone" dataKey="Utilization" stroke="#0077B9" activeDot={{ r: 4 }} strokeWidth={2} />

                                                        </ComposedChart>
                                                    </ResponsiveContainer>
                                                    : error107 ?
                                                        <p className='text-center'><b>Please Select Equipment ID First</b></p>
                                                        : <p className='text-center'><b>No Data Available</b></p>
                                            }
                                        </div>
                                    </div>
                                </div>
                        }
                    </Tab>
                    <Tab eventKey="third" title="Equipment Shift Operator">
                        {
                            dashboard.indexOf(108) == -1 ? "" :
                                <div className="row card-box-block mt-3">
                                    <div className="col-sm-12">
                                        <div className="row">
                                            <div className="col-sm-10">
                                                <h6 className='cardtitle'>Shift Wise Data (%)</h6>
                                            </div>
                                            <div className="col-sm-2  text-end">
                                                <FontAwesomeIcon icon={faBars} onClick={() => handleShow(108)} />
                                            </div>
                                        </div>
                                        <hr />
                                        {
                                            shiftWise.length ?
                                                <Table columns={shiftCol} data={shiftWise} />
                                                :
                                                <p className='text-center'><b>No Data Available</b></p>
                                        }
                                    </div>
                                </div>
                        }
                        {
                            dashboard.indexOf(109) == -1 ? "" :
                                <div className="row card-box-block mt-3">
                                    <div className="col-sm-12">
                                        <div className="row">
                                            <div className="col-sm-10">
                                                <h6 className='cardtitle'>Operator Wise Data</h6>
                                            </div>
                                            <div className="col-sm-2  text-end">
                                                <FontAwesomeIcon icon={faBars} onClick={() => handleShow(109)} />
                                            </div>
                                        </div>
                                        <hr />
                                        {
                                            operatorWise.length ?
                                                <Table columns={columns_operator} data={operatorWise} func={getOperatorEquipmentUtilization} />
                                                :
                                                <p className='text-center'><b>No Data Available</b></p>
                                        }
                                    </div>
                                </div>
                        }
                        {
                            dashboard.indexOf(110) == -1 ? "" :
                                <div className="row card-box-block mt-3">
                                    <div className="col-sm-12">
                                        <div className="row">
                                            <div className="col-sm-10">
                                                <h6 className='cardtitle'>Equipment Wise Data</h6>
                                            </div>
                                            <div className="col-sm-2  text-end">
                                                <FontAwesomeIcon icon={faBars} onClick={() => handleShow(110)} />
                                            </div>
                                        </div>
                                        <hr />
                                        {
                                            equipmentWise.length ?
                                                <Table columns={columns_equipment} data={equipmentWise} />
                                                :
                                                <p className='text-center'><b>No Data Available</b></p>
                                        }
                                    </div>
                                </div>
                        }
                    </Tab>
                </Tabs>
            </div>
            <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
                <Modal.Header>
                    <Modal.Title>Filter</Modal.Title>
                    <button onClick={handleClose} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className='row'>
                        {
                            filterDash == 103 || filterDash == 106 || filterDash == 108 ?
                                filterDash == 106 ?
                                    <>
                                        {/* for week validation */}
                                        <div className='col-sm-4'>
                                            <Form.Group className="mb-2" >
                                                <label>From Date</label>
                                                <Form.Control type='date' name='fromDate' value={filter.fromDate}
                                                    className="textbox-back" onChange={getFilterData} max={today} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-sm-4'>
                                            <Form.Group className="mb-2" >
                                                <label>To Date</label>
                                                <Form.Control type='date' name='toDate' value={filter.toDate} min={filter.fromDate} max={filter.fromDate == ""?today: lastDate}
                                                    className="textbox-back" onChange={getFilterData} />
                                            </Form.Group>
                                            <small className='red'>Maximum 8 weeks are allowed to select</small>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className='col-sm-4'>
                                            <Form.Group className="mb-2" >
                                                <label>From Date</label>
                                                <Form.Control type='date' name='fromDate' value={filter.fromDate}
                                                    className="textbox-back" onChange={getFilterData} max={today} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-sm-4'>
                                            <Form.Group className="mb-2" >
                                                <label>To Date</label>
                                                <Form.Control type='date' name='toDate' value={filter.toDate} min={filter.fromDate}
                                                    className="textbox-back" onChange={getFilterData} max={today} />
                                            </Form.Group>
                                        </div>
                                    </>
                                :
                                ""
                        }
                        {
                            filterDash == 103 || filterDash == 108 || filterDash == 106 || filterDash == 107 ?
                                <div className='col-sm-4'>
                                    <Form.Group className="mb-2" >
                                        <label>Month</label>
                                        <Form.Control type='month' name='month' value={filter.month}
                                            className="textbox-back" onChange={getFilterData} max={yyyy + "-" + mm} />
                                    </Form.Group>
                                </div>
                                : ""
                        }
                        {
                            filterDash == 103 || filterDash == 108 || filterDash == 105 ?
                                <div className='col-sm-4'>
                                    <Form.Group className="mb-2 " >
                                        <label>Year</label>
                                        <Form.Select as='select' placeholder='year' name='year' value={filter.year}
                                            className="textbox-back" onChange={getFilterData}>
                                            <option value="">Select Year</option>
                                            {
                                                years.map((item, index) =>
                                                    <option key={index} value={item}>{item}</option>
                                                )
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                :
                                ""
                        }

                        <div className='col-sm-4 '>
                            <Form.Group className="mb-2" >
                                <label>Product Category</label>
                                <Form.Select as='select' name='productCategoryID' className="textbox-back" value={filter.productCategoryID} onChange={getFilterData}>
                                    {filterDash == 102 ? null : <option value="">Select Category</option>}
                                    {
                                        cate.map((item, index) =>
                                            <option key={index} value={item.categoryID}>{item.categoryName}</option>
                                        )
                                    }
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className='col-sm-4 '>
                            <Form.Group className="mb-2" >
                                <label>Product Sub Category</label>
                                <Form.Select as='select' name='productSubCategoryID' className="textbox-back" value={filter.productSubCategoryID} onChange={getFilterData}>
                                    <option value="">Select Category</option>
                                    {
                                        subCate.map((item, index) =>
                                            <option key={index} value={item.categoryID}>{item.categoryName}</option>
                                        )
                                    }
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className='col-sm-4 '>
                            <Form.Group className="mb-2" >
                                <label>Site</label>
                                <Form.Select as='select' name='siteID' className="textbox-back" value={filter.siteID} onChange={getFilterData}>
                                    {
                                        filterDash == 109 || filterDash == 103 || filterDash == 105 || filterDash == 106 || filterDash == 107 || filterDash == 108 ? <option disabled value="">Select Site</option>
                                            : <option value="">Select Site</option>
                                    }

                                    {
                                        siteList.map((item, index) =>
                                            <option key={index} value={item.siteID}>{item.siteName}</option>
                                        )
                                    }
                                </Form.Select>


                            </Form.Group>
                        </div>
                        {
                            filterDash == 102 || filterDash == 104 ? ""
                                :
                                <>
                                    <div className='col-sm-4'>
                                        <Form.Group className="mb-2" >
                                            <label>Equipment ID</label>
                                            <Form.Select as='select' name='equipmentID' className="textbox-back" value={filter.equipmentID} onChange={getFilterData}>
                                                <option value="">Select Equipment ID</option>
                                                {
                                                    allAseet.map((item, index) =>
                                                        <option key={index} value={item.assetID}>{item.assetID}</option>
                                                    )
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                    <div className='col-sm-4 '>
                                        <Form.Group className="mb-2" >
                                            <label>Equipment Type</label>
                                            <Form.Select as='select' name='equipmentType' className="textbox-back" value={filter.equipmentType} onChange={getFilterData}>
                                                <option value="">Select Equipment Type</option>
                                                {
                                                    (dropdownData.asset_equipmentType).map((item, index) =>
                                                        <option key={index} value={item.name}>{item.name}</option>
                                                    )
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                </>

                        }

                    </div>
                    <div className="row justify-content-center mt-4">
                        <button className="btn btn-outline-secondary lo-btn" onClick={() => clearFilter(filterDash)}>
                            Reset
                        </button>
                        <button className="add-btn btn-light lo-btn confirm-btn mx-3" onClick={getFilterFields}>
                            Apply
                        </button>
                        <button className="add-btn btn-light lo-btn confirm-btn" onClick={saveGlobelFilter}>
                            Apply All
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            {/* for operator hour */}
            <Modal show={showOpHr} onHide={opHrClose} centered backdrop="static" size="lg">
                <Modal.Header>
                    <Modal.Title>{operatorHrs.operatorName}</Modal.Title>
                    <button onClick={opHrClose} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className="row">
                        <div className="col-sm-12">
                            <Table columns={columns_opHr} data={operatorHrs.data} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Utilization
